package ar.corzo.health_tracker.types.state

sealed class StateData<out DT:Any?>(open val data:DT?=null){
	companion object{
		fun <VALUE> VALUE?.toStateData(messageOnError: String? = null) = if(this==null) Error(messageOnError) else Success(this)
	}
	data class Success<Data:Any>(override val data: Data):StateData<Data>(data)
	data class Error(val message:String?=null):StateData<Nothing>()
	data object Loading:StateData<Nothing>()

	fun toState() = when(this){
		is Error -> State.Error
		Loading -> State.Loading
		is Success<*> -> State.Success
	}
}